module.exports = __webpack_public_path__ + "static/media/no_comments.ca29e77c.png";